import { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
    fetchMainShipImage,
    fetchScreeningData,
    selectScreeningByIMO,
    selectScreeningLoading
} from "../features/screeningSlice";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { ScreeningHeader } from "../components/screening/ScreeningHeader";
import { ScreeningTabs } from "../components/screening/ScreeningTabs";

export const Screening = () => {
    const dispatch = useAppDispatch();
    const { imo } = useParams();

    const loading = useAppSelector(selectScreeningLoading);
    const data = selectScreeningByIMO(imo);

    useEffect(() => {
        if (imo) {
            dispatch(fetchScreeningData(imo));
            dispatch(fetchMainShipImage(imo));
        }
    }, []);

    return (
        <div className={"inspection-page-wrapper"}>
            <div>
                <ScreeningHeader data={data} loading={loading} />
                <ScreeningTabs data={data} loading={loading} />
            </div>
        </div>
    );
};
